import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialogRef } from "@angular/material/dialog";

import { ToastrService } from "ngx-toastr";
import { BundleService } from "src/app/Services/bundleservice.service";
import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";

@Component({
  selector: "app-delete-bundle-dialog",
  templateUrl: "./delete-bundle-dialog.component.html",
  styleUrls: ["./delete-bundle-dialog.component.scss"],
})
export class DeleteBundleDialogComponent implements OnInit {
  userData: any;
  bundleData: any;
  noResultReturned: boolean;
  bundleId: any;
  isDeleting = false;

  constructor(
    private toastr: ToastrService,
    private flowServiceService: FlowServiceService,
    private bundleService: BundleService,
    public formbuilder: UntypedFormBuilder,
    private dataService: DataService,
    public router: Router,
    private activateRouter: ActivatedRoute,
    private dialogRef: MatDialogRef<DeleteBundleDialogComponent>
  ) {}

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.bundleId = localStorage.getItem("bundleIdToBeDeleted");
    this.bundleData = JSON.parse(localStorage.getItem("bundleData"));
  }

  presetUserSettings() {
    if (this.isDeleting) {
      return;
    }

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData.emailAddress != this.bundleData.customerEmail) {
      this.presentCurrentUserOptions();
    } else {
      this.deleteBundle();
    }
  }

  presentCurrentUserOptions() { }

  deleteBundle() {
    this.isDeleting = true;
    var bundleModel = {
      rowKey: this.bundleId,
      CustomerEmail: this.userData.emailAddress,
      BundleStatus: "Approved",
    };
    console.log(bundleModel);
    this.noResultReturned = true;
    var navigateTo = localStorage.getItem("navigateTo");
    if (this.userData.emailAddress == this.bundleData.customerEmail) {
      if (this.bundleId > 0) {
        this.bundleService.deleteBundle(bundleModel).subscribe({
          next: (data) => {
            this.noResultReturned = false;
            this.isDeleting = false;
            if (data) {
              this.showToastForDelete();
              this.dialogRef.close(true);
              setTimeout(() => this.router.navigate(["/user-profile"]), 0);
            }
          },
          error: () => {
            this.isDeleting = false;
            this.noResultReturned = false;
            this.toastr.error("Could not delete bundle. Please try again.");
          },
        });
      } else {
        this.isDeleting = false;
      }
    } else {
      this.isDeleting = false;
      this.router.navigate(["/view-guide-pack/" + this.bundleData.rowKey]);
      this.dialogRef.close(false);
    }
  }

  showToastForDelete() {
    this.toastr.success("Bundle successfully Deleted");
  }
}
